interface LogoProps {
  /** Path to the full-size brand PNG — siteConfig.logo or siteConfig.logoLight. */
  src: string;
  alt: string;
  className?: string;
  loading?: "eager" | "lazy";
  /** Set when a surrounding link already carries the accessible name. */
  decorative?: boolean;
}

/**
 * The wordmark, in the places it is drawn small.
 *
 * The source PNG is 900px wide but the header and footer paint it at roughly
 * 115-165 CSS px, so this offers a 500px WebP first — sharp on a 3x screen at
 * less than half the bytes — and keeps the PNG as the fallback. Intrinsic
 * width/height are always set so the header reserves its space before the
 * image arrives.
 *
 * Not for the gallery placeholder, which draws the logo large enough to want
 * the full-resolution file.
 */
const Logo = ({ src, alt, className, loading = "eager", decorative = false }: LogoProps) => {
  const webp = src.replace(/\.png$/i, "-500.webp");
  return (
    <picture className="contents">
      <source type="image/webp" srcSet={webp} />
      <img
        src={src}
        alt={decorative ? "" : alt}
        aria-hidden={decorative || undefined}
        className={className}
        width={900}
        height={351}
        loading={loading}
        decoding="async"
      />
    </picture>
  );
};

export default Logo;
